/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class Format implements angular.IDirective {
    private filter: angular.IFilterService;
    link = (scope: angular.IScope, elem: angular.IAugmentedJQuery, attrs: angular.IAttributes, ctrl: angular.INgModelController) => {
      var filter = this.filter;

      if (!ctrl) return;

      var format = attrs["format"] === "" ? "number" : attrs["format"];

      ctrl.$formatters.unshift((): angular.IModelFormatter => <any>filter(format)(ctrl.$modelValue));

      ctrl.$parsers.unshift(viewValue => {
        var plainNumber = viewValue.replace(/[^\d|\-+|\.+]/g, "");
        elem.val(filter(format)(plainNumber));
        return plainNumber;
      });
    }
    require = "?ngModel";

    constructor($filter: angular.IFilterService) {
      this.filter = $filter;
    }

    static factory(): angular.IDirectiveFactory {
      let directive = ($filter) => {
        return new Format($filter);
      };

      directive.$inject = ["$filter"];

      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("format", Format.factory());
}